import { Map } from 'immutable';
import { configureStore } from './configureStore';

const initialState = Map();

export const store = configureStore(initialState);
